// ── REVEAL ANIMATION ──
const revealObserver = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('visible'); revealObserver.unobserve(e.target); }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ── SMOOTH SCROLL ──
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});

// ── FAQ ACCORDION ──
function toggleFaq(el) {
  const answer = el.nextElementSibling;
  const isOpen = el.classList.contains('open');
  el.classList.toggle('open', !isOpen);
  answer.classList.toggle('open', !isOpen);
}
// Allow calling via onclick attribute in Liquid sections
window.toggleFaq = toggleFaq;

// ── AJAX CART ──
window.updateCartCount = updateCartCount;
function updateCartCount(count) {
  let countEl = document.getElementById('cart-count');
  const cartBtn = document.getElementById('cart-btn');
  if (count > 0) {
    if (!countEl && cartBtn) {
      countEl = document.createElement('span');
      countEl.id = 'cart-count';
      countEl.className = 'cart-count';
      cartBtn.appendChild(countEl);
    }
    if (countEl) countEl.textContent = count;
  } else {
    if (countEl) countEl.remove();
  }
}

// Reads zone-aware unit price off the closest element to `form` that carries
// data-shippo-rates (the source-input attribute the DPE refactor introduced).
// Computation is delegated to MasterCaseZonePricing.resolveUnitPrice so the
// formula stays in one place. Falls back to the variant price (base unit
// price on the element) if no zone is set, no source inputs are found, or
// the zone has no priced market (e.g. NORTH territories — handled at the
// storefront with a contact-us notice).
function resolveZoneUnitPrice(form) {
  try {
    const zone = localStorage.getItem('mc_zone');
    if (!zone) return null;
    const src = form.querySelector('[data-shippo-rates]')
             || form.closest('[data-shippo-rates]')
             || (form.parentElement && form.parentElement.querySelector('[data-shippo-rates]'));
    if (!src) return null;
    if (!window.MasterCaseZonePricing || typeof window.MasterCaseZonePricing.resolveUnitPrice !== 'function') {
      return null;
    }
    const unitPrice = window.MasterCaseZonePricing.resolveUnitPrice(src, zone);
    if (!isFinite(unitPrice) || unitPrice <= 0) return null;
    return { unitPrice: unitPrice, zone: zone };
  } catch (e) { return null; }
}

async function ajaxAddToCart(variantId, quantity, btn, zonePrice) {
  const origText = btn.textContent;
  btn.textContent = 'Adding…';
  btn.disabled = true;
  try {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) || 1 })
    });
    if (addRes.ok) {
      const addedItem = await addRes.json(); // line item that was just added/updated
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartCount(cart.item_count);
      showAtcPopup(addedItem, cart, zonePrice);
      btn.textContent = '✓ Added';
      btn.style.background = '#2E7D32';
      setTimeout(() => {
        btn.textContent = origText;
        btn.style.background = '';
        btn.disabled = false;
      }, 1800);
    } else {
      btn.textContent = 'Error — try again';
      btn.style.background = '#C0392B';
      btn.disabled = false;
    }
  } catch {
    btn.textContent = 'No connection — try again';
    btn.style.background = '#C0392B';
    btn.disabled = false;
  }
}

// ── LIMITED TIME OFFER: ONE IMPLEMENTATION ────────────────────────────────
// Used by the add-to-cart popup (showAtcPopup, below) and by the cart page in
// zone-pricing.js, so the two can never disagree. Thresholds and the formatted
// money strings live in window.MasterCaseConfig, which layout/theme.liquid
// builds from Theme settings > Limited Time Offer. That is the single source of
// truth: no threshold is hardcoded in any template, asset or script.
//
// grossCents MUST be the PRE-discount subtotal. Shopify applies the automatic
// discount in the cart, so cart.total_price is already net of it and using that
// would push a qualifying cart back below its own threshold.
//
// Returns the money string already saved ('$10.00'), or '' when nothing is
// unlocked. '' means render nothing at all: there is deliberately no "spend
// $X more" branch anywhere in this file.
function mcOfferSaved(grossCents, isFr) {
  var c = window.MasterCaseConfig || {};
  if (!c.offerActive) return '';
  if (typeof grossCents !== 'number' || !isFinite(grossCents)) return '';
  if (grossCents >= c.offerT2Cents) return isFr ? c.offerA2MoneyFr : c.offerA2Money;
  if (grossCents >= c.offerT1Cents) return isFr ? c.offerA1MoneyFr : c.offerA1Money;
  return '';
}

// Green check plus the sentence, EN or FR. Kept here so the popup and the cart
// line read identically, word for word.
// 🔒 WORDING, 2026-11-02 (Mike): it must say "Additional $10 applied", NOT
// "You're saving $10". The cart card already carries a green "You save $X off
// retail MSRP" line, and two savings sentences in the same box read as one
// number and make the MSRP saving look like the whole discount. "Additional"
// says this comes ON TOP of it.
// 🔒 "at checkout" is load-bearing too (Mike, same day): in the ADD-TO-CART
// POPUP nothing has moved yet, because the popup shows the item price and that
// does not change, so a bare "applied" reads as a contradiction. In the cart the
// amount is already inside the Total, so "at checkout" is simply where it is
// charged. One sentence covers both places; do not split them.
function mcOfferSavedText(savedMoney, isFr) {
  return '✓ ' + (isFr
    ? 'Rabais supplémentaire de ' + savedMoney + ' appliqué au paiement'
    : 'Additional ' + savedMoney + ' applied at checkout');
}

window.mcOfferSaved     = mcOfferSaved;
window.mcOfferSavedText = mcOfferSavedText;


// ── ADD-TO-CART POPUP ──
function showAtcPopup(item, cart, zonePrice) {
  const popup = document.getElementById('mc-atc-popup');
  if (!popup) return;

  // zonePrice (computed at submit time from the form's [data-shippo-rates]
  // via MasterCaseZonePricing.resolveUnitPrice) gives us a per-UNIT price for
  // the current zone. If absent, fall back to line_price (variant price × qty).
  let displayPrice;
  if (zonePrice && typeof zonePrice.unitPrice === 'number') {
    displayPrice = (zonePrice.unitPrice * item.quantity).toFixed(2);
  } else {
    displayPrice = (item.line_price / 100).toFixed(2);
  }

  document.getElementById('mc-atc-popup-img').src = item.image
    ? item.image.replace(/(_[0-9]+x[0-9]+)?(\.[a-z]+)$/, '_160x160$2')
    : '';
  document.getElementById('mc-atc-popup-title').textContent = item.product_title || item.title || '';
  document.getElementById('mc-atc-popup-vendor').textContent = '';  // brand is in the product title; hide seller-entity name
  document.getElementById('mc-atc-popup-qty').textContent = '\u00d7 ' + item.quantity;
  document.getElementById('mc-atc-popup-price').textContent = '$' + displayPrice;

  // ── LIMITED TIME OFFER, SAVING ALREADY UNLOCKED ───────────────────────
  // 2026-11-02. This reports ONLY a saving the shopper has ALREADY earned.
  // No next tier, no "spend $X more", no progress bar, and nothing at all
  // below tier 1. Mike: shoppers were not topping up to reach a threshold,
  // so the prompt was noise in the place they were already dropping.
  // Thresholds and the pre-formatted money strings come from
  // window.MasterCaseConfig, built by layout/theme.liquid from
  // Theme settings > Limited Time Offer. Never hardcode a threshold here.
  const offerEl = document.getElementById('mc-atc-popup-offer');
  if (offerEl && cart && typeof cart.total_price === 'number') {
    const FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
    // cart.total_price is NET of the automatic discount, because Shopify applies
    // it in the CART, not at checkout. Add it back to measure the thresholds.
    // 2026-10-24: subtracting it again for display showed a figure $10 below
    // what the shopper would actually be charged. Do not re-subtract.
    const gross = cart.total_price + (typeof cart.total_discount === 'number' ? cart.total_discount : 0);
    const saved = mcOfferSaved(gross, FR);
    if (saved) {
      offerEl.innerHTML = mcOfferSavedText(saved, FR);
      offerEl.style.display = 'block';
    } else {
      offerEl.style.display = 'none';
    }
  } else if (offerEl) {
    // No cart in hand. Hide the line rather than leave the previous popup's
    // figure on screen against a different total.
    offerEl.style.display = 'none';
  }

  popup.style.display = 'block';
  popup.setAttribute('aria-hidden', 'false');

  // Auto-close after 8 seconds
  if (window._mcAtcTimer) clearTimeout(window._mcAtcTimer);
  window._mcAtcTimer = setTimeout(hideAtcPopup, 8000);
}

function hideAtcPopup() {
  const popup = document.getElementById('mc-atc-popup');
  if (!popup) return;
  popup.style.display = 'none';
  popup.setAttribute('aria-hidden', 'true');
  if (window._mcAtcTimer) clearTimeout(window._mcAtcTimer);
}

document.addEventListener('click', function (e) {
  if (e.target && e.target.id === 'mc-atc-popup-close') hideAtcPopup();
});

document.addEventListener('submit', async function(e) {
  const form = e.target;
  if (!form.hasAttribute('data-ajax-cart')) return;
  e.preventDefault();
  const btn = form.querySelector('button[type="submit"]');
  const variantId = form.querySelector('input[name="id"]').value;
  const qty = form.querySelector('[name="quantity"]');
  const zonePrice = resolveZoneUnitPrice(form);
  await ajaxAddToCart(variantId, qty ? qty.value : 1, btn, zonePrice);
});

// ── NEWSLETTER SUBMIT ──
// Posts to Shopify's Storefront API customerCreate mutation. The Storefront
// API endpoint (/api/<version>/graphql.json) does NOT trigger Shopify's Bot
// Defense / hCaptcha — that's reserved for the /contact form endpoint. This
// path creates a real Shopify customer record with newsletter consent and
// applied tags, with no captcha friction. Replaces the earlier /contact and
// Formspree integrations.
const STOREFRONT_API_VERSION = '2024-01';
const STOREFRONT_TOKEN = 'f28cb82be686d53bd8b336dcd36ab5ac';

async function submitNewsletter(e) {
  e.preventDefault();
  const form     = e.target,
        btn      = form.querySelector('button[type="submit"]'),
        origText = btn.textContent;

  btn.textContent = 'Joining…';
  btn.disabled    = true;

  const email = (form.querySelector('input[type="email"]')?.value || '').trim();
  if (!email) {
    btn.textContent = origText;
    btn.disabled    = false;
    return;
  }

  // Pull tags from hidden input — fall back to defaults if absent.
  const tagsValue = form.querySelector('[name="contact[tags]"]')?.value || 'prospect,waitlist,newsletter';
  const tags = tagsValue.split(',').map(function (t) { return t.trim(); }).filter(Boolean);

  const query = '\n    mutation customerCreate($input: CustomerCreateInput!) {\n      customerCreate(input: $input) {\n        customer { id email }\n        customerUserErrors { field message }\n      }\n    }';

  const variables = {
    input: {
      email: email,
      tags: tags,
      emailMarketingConsent: {
        marketingState: 'SUBSCRIBED',
        marketingOptInLevel: 'SINGLE_OPT_IN'
      }
    }
  };

  function showSuccess(msg) {
    btn.textContent      = msg || '✓ You\'re on the list! Welcome to MasterCase Canada 🍁';
    btn.style.background = '#2E7D32';
    form.reset();
  }
  function showRetry(msg) {
    btn.textContent      = msg;
    btn.style.background = '#C0392B';
    btn.disabled         = false;
    setTimeout(function () { btn.textContent = origText; btn.style.background = ''; }, 3000);
  }

  try {
    const resp = await fetch('/api/' + STOREFRONT_API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables })
    });
    const json = await resp.json();
    // Check for top-level GraphQL errors (auth/throttling/scope failures
    // surface here, NOT in customerUserErrors). Without this check the code
    // silently shows success when the API call actually failed.
    const topErrors = json && json.errors;
    if (topErrors && topErrors.length) {
      console.error('Storefront API top-level errors:', topErrors);
      showRetry('Could not connect — please try again');
      return;
    }
    const created = json && json.data && json.data.customerCreate && json.data.customerCreate.customer;
    const userErrors = json && json.data && json.data.customerCreate && json.data.customerCreate.customerUserErrors;
    if (userErrors && userErrors.length) {
      const msg = (userErrors[0].message || '').toLowerCase();
      if (msg.indexOf('taken') !== -1 || msg.indexOf('already') !== -1) {
        showSuccess('✓ You\'re already on the list — see you at launch.');
      } else {
        console.error('Storefront API user errors:', userErrors);
        showRetry('Something went wrong — please try again');
      }
    } else if (created) {
      showSuccess();
    } else {
      console.error('Unexpected Storefront API response:', json);
      showRetry('Something went wrong — please try again');
    }
  } catch (err) {
    showRetry('No connection — please try again');
  }
}
window.submitNewsletter = submitNewsletter;

// Attach to any .newsletter-form rendered by the {% form 'customer' %} helper.
// Document-level delegation (same pattern as data-ajax-cart above) so this works
// regardless of script load order — DOMContentLoaded-based attachment was a
// silent failure when this file ran with `defer` after the event had fired.
document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form || !form.classList || !form.classList.contains('newsletter-form')) return;
  submitNewsletter(e);
});
